var _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52:15257)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#8A8A8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6897 47.9765L45.5774 47.9765C46.517 47.9765 47.0007 47.1341 47.0007 46.2868V26.734C47.0007 25.9046 46.4068 25.2036 45.5774 25.0655L34.9669 25C34.4483 25 33.9771 25.055 33.5977 25.3775C33.2182 25.7 33 26.1693 33 26.6675V46.2868C33 47.2186 33.758 47.9765 34.6897 47.9765ZM37.0236 43.8052V47.9764H42.977V43.8052C42.977 42.9107 42.1981 42.183 41.2406 42.183H38.76C37.8025 42.183 37.0236 42.9107 37.0236 43.8052ZM39.0348 30.1135C39.0348 30.3801 38.8186 30.5962 38.552 30.5962H36.6209C36.3542 30.5962 36.1381 30.3801 36.1381 30.1135V28.1823C36.1381 27.9157 36.3542 27.6996 36.6209 27.6996H38.552C38.8186 27.6996 39.0348 27.9157 39.0348 28.1823V30.1135ZM38.552 35.4241C38.8186 35.4241 39.0348 35.2079 39.0348 34.9413V33.0101C39.0348 32.7435 38.8186 32.5274 38.552 32.5274H36.6209C36.3542 32.5274 36.1381 32.7435 36.1381 33.0101V34.9413C36.1381 35.2079 36.3542 35.4241 36.6209 35.4241H38.552ZM39.0348 39.7691C39.0348 40.0357 38.8186 40.2519 38.552 40.2519H36.6209C36.3542 40.2519 36.1381 40.0357 36.1381 39.7691V37.838C36.1381 37.5713 36.3542 37.3552 36.6209 37.3552H38.552C38.8186 37.3552 39.0348 37.5713 39.0348 37.838V39.7691ZM43.3798 30.5962C43.6464 30.5962 43.8626 30.3801 43.8626 30.1135V28.1823C43.8626 27.9157 43.6464 27.6996 43.3798 27.6996H41.4487C41.182 27.6996 40.9659 27.9157 40.9659 28.1823V30.1135C40.9659 30.3801 41.182 30.5962 41.4487 30.5962H43.3798ZM43.8626 34.9413C43.8626 35.2079 43.6464 35.4241 43.3798 35.4241H41.4487C41.182 35.4241 40.9659 35.2079 40.9659 34.9413V33.0101C40.9659 32.7435 41.182 32.5274 41.4487 32.5274H43.3798C43.6464 32.5274 43.8626 32.7435 43.8626 33.0101V34.9413ZM43.3798 40.2519C43.6464 40.2519 43.8626 40.0357 43.8626 39.7691V37.838C43.8626 37.5713 43.6464 37.3552 43.3798 37.3552H41.4487C41.182 37.3552 40.9659 37.5713 40.9659 37.838V39.7691C40.9659 40.0357 41.182 40.2519 41.4487 40.2519H43.3798Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52:15257",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52:15257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52:15257",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteOffline);
export default __webpack_public_path__ + "static/media/siteOffline.71d329ce.svg";
export { ForwardRef as ReactComponent };